const app_promo = {
  "app_promo.block_title": "<span>Enjoy exclusive</span> <span><em>ACUVUE® privileges</em></span> <span>at your fingertips</span>",
  "app_promo.li_01": "Enjoy exclusive offers",
  "app_promo.li_02": "Earn points for every ringgit spent",
  "app_promo.li_03": "Redeem points for savings on your next purchase",
  "app_promo.cta_title": "Enjoy RM50 of your first purchase",
  "app_promo.cta_btn": "<a>Learn More</a>",
  "app_promo.cta_link": "https://www.acuvue.com.my/myacuvue"
}

export default app_promo;
